import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { NotifierService } from 'angular-notifier';
import { stringify } from 'querystring';
import { throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment,environment_accessErrMsg } from 'src/environments/environment';
import { Globals } from './global';
import { UtilityService } from './utility.service';
import { ReportService } from './report.service';
@Injectable({
  providedIn: 'root'
})
export class PermissionService{
  httpHeaders: any;
  jsonTest: any;
  private readonly notifier!: NotifierService;
  constructor(private globals:Globals,private readonly notifierService: NotifierService,private http: HttpClient,public utils:UtilityService,public report:ReportService) {
    this.httpHeaders = new HttpHeaders().set('Content-Type', 'application/json;charset=utf-8').set("Access-Control-Allow-Origin", "*")
      .set("Access-Control-Allow-Headers", "*")
      .set("Access-Control-Allow-Methods", "GET,POST,PUT,DELETE");
      this.notifier = notifierService;
  }
  checkUserRightsWithAlert(moduleName:any, permission:any) {
    var rightsMap:any;
    rightsMap = localStorage.getItem('userRightsMap');
    
    rightsMap = JSON.parse(rightsMap);
    if(rightsMap!=null && rightsMap[moduleName] != null && rightsMap[moduleName].indexOf(permission) != -1){
      return true;
    }else{
      var errorMsg:any='';
      if(permission==this.utils.permissionType.READ){
        errorMsg = environment_accessErrMsg.msg_viewrightsalert;
      }else if(permission==this.utils.permissionType.MODIFY){
        errorMsg = environment_accessErrMsg.msg_modifyrightsalert;
      }
      else if(permission==this.utils.permissionType.ADD){
        errorMsg = environment_accessErrMsg.msg_addrightsalert;
      }
      else if(permission==this.utils.permissionType.DELETE){
        errorMsg = environment_accessErrMsg.msg_deleterightsalert;
      }
      // this.notifier.show({
      //   type: 'Warn',
      //   message: errorMsg
      // });
      
    }
    return true;
  }
 //Method user to validate rights without providing rights
  checkUserRightsWithNoAlert(moduleName:any, permission:any) {
    var rightsMap:any;
    rightsMap = localStorage.getItem('userRightsMap');
    
    rightsMap = JSON.parse(rightsMap);
    if(rightsMap!=null && rightsMap[moduleName] != null && rightsMap[moduleName].indexOf(permission) != -1){
     return true;
    }
    return true;
  }
  
  checkRoleRightsWithAlert(moduleName:any, permission:any) {
    var rightsMap:any;
    rightsMap = this.globals.roleRightsMap;
    
    // rightsMap = JSON.parse(rightsMap);
  
    if(rightsMap!=null && rightsMap[moduleName] != null && rightsMap[moduleName].indexOf(permission) != -1){
      return true;
    }else{
      var errorMsg:any='';
      if(permission==this.utils.permissionType.READ){
        errorMsg = environment_accessErrMsg.msg_viewrightsalert;
      }else if(permission==this.utils.permissionType.MODIFY){
        errorMsg = environment_accessErrMsg.msg_modifyrightsalert;
      }
      else if(permission==this.utils.permissionType.ADD){
        errorMsg = environment_accessErrMsg.msg_addrightsalert;
      }
      else if(permission==this.utils.permissionType.DELETE){
        errorMsg = environment_accessErrMsg.msg_deleterightsalert;
      }
      // this.notifier.show({
      //   type: 'Error',
      //   message: errorMsg
      // });
      
    }
    return true;
  }

  checkRoleRightsWithNoAlert(moduleName:any, permission:any) {
    var rightsMap:any;
    rightsMap = this.globals.roleRightsMap;
    
    //rightsMap = JSON.parse(rightsMap);
  
    if(rightsMap!=null && rightsMap[moduleName] != null && rightsMap[moduleName].indexOf(permission) != -1){
      return true;
    }
    return true;
  }
  
  checkPhemeRightsWithNoAlert(moduleName:any, permission:any,permissionData:any) {
    var rightsMap:any;
    rightsMap = permissionData.moduleMap;
    if(rightsMap!=null && rightsMap[moduleName] != null && rightsMap[moduleName].indexOf(permission) != -1){
        return true;
    }
    return false;
  }

  checkPhemeReportRightsWithNoAlert(moduleName:any, permission:any,permissionData:any) {
    var userData={
      loginName : permissionData.loginName,
      loginKey : permissionData.loginKey,
      source : "DS_AgoraReports_1",
     }
    this.report.getAllReports(userData).subscribe(data=>{
      return true;
    },error=>{
      return false;
    })
    return true;
    
  }
  
}
